import React from "react";
import { useTranslations } from "next-intl";
import { CompetitorComparison as CompetitorComparisonUI } from "@carfax/web-ui/components/CompetitorComparison";
import { ModuleCompetitorComparison } from "@carfax/contentful/PageModularModule";

interface Props {
  module: ModuleCompetitorComparison;
}

const CompetitorComparison: React.FC<Props> = ({ module }) => {
  const t = useTranslations("page-index.competitorComparison");

  return (
    <CompetitorComparisonUI
      headline={module.headline}
      text={module.text}
      carfaxLogoAlt={t("carfaxLogoAlt")}
      labelColumnHeader={t("labelColumnHeader")}
      otherColumnLabel={t("otherColumnLabel")}
      rowLabels={[
        t("rowDamagesDomestic"),
        t("rowDamagesAbroad"),
        t("rowDamageSeverity"),
        t("rowDamageCause"),
        t("rowDamagedAreas"),
      ]}
      iconDescTrophy={t("iconDescTrophy")}
      iconDescCheck={t("iconDescCheck")}
      iconDescCancel={t("iconDescCancel")}
    />
  );
};

export default CompetitorComparison;
